/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@edx/paragon';
import { Info } from '@edx/paragon/icons';

export const Banner = ({
  children, variant, icon, className,
}) => {
  const iconStyle = { color: '#079845', marginRight: '.5rem' };

  return (
    <Alert variant={variant} className={`${className} r4c-dashboard-alert-msg`}>
      <p className='r4c-dashboard-alert-message-text'>
        <div className="r4c-alert-icon-wrapper">
          <Info style={iconStyle} />
        </div>
        {children}
      </p>
    </Alert>
  );
};

Banner.defaultProps = {
  variant: 'info',
  className: 'mb-0',
};

Banner.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Banner;
